/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Max_Cps_LabelInputs */



/**
* | output |
* | --- |
* | "Maximum Characters Per Second (CPS)" |
*
* @param {Style_Guide_Manager_Max_Cps_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_max_cps_label = /** @type {((inputs?: Style_Guide_Manager_Max_Cps_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Max_Cps_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Caracteres maximum par seconde (CPS)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Maximale Zeichen pro Sekunde (ZP/s)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero massimo di caratteri al secondo (CPS)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Максимальное количество символов в секунду (CPS)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Máximo de caracteres por segundo (CPS)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每秒最大字符数 (CPS)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1秒あたりの最大文字数（CPS）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रति सेकंड अधिकतम अक्षर (सीपीएस)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Número máximo de caracteres por segundo (CPS)")
	return /** @type {LocalizedString} */ ("Maximum Characters Per Second (CPS)")
});